export const STATE_SELECTION_ALL = "All";
export const PRACTITIONER_DEFAULT = "Practitioner";
